<template>
  <div class="admin-domain-common-info-scene">

    <template v-if="!loading">

      <div class="domain-info-wrapper basic-form">
        <div class="row-block">
            <label>{{ $tr('settings.domain.form.domain') }}*</label>
            <div class="flex-block">
              <div class="flex-block flex-block--column">
                <input type="text" style="width: 400px; text-align: right"
                  name="name" v-validate="'required'"
                  v-model="model.domain_prefix" :placeholder="company_domain_prefix" />
                <div class="error bold">{{$tr('settings.domain.form.notification')}}</div>
              </div>
              <input type="text" style="width: 200px"
                v-model="domain_postfix" :disabled="true" />
            </div>
        </div>
      </div>

      <div>
        <vbutton
          label="actions.save"
          :disabled="false"
          @click="update" />
      </div>
    </template>
  </div>
</template>

<script>
import { STORE_PREFIX } from '../../constants.js';
import { mapGetters } from 'vuex';
import {isDomainRu} from '@/_helpers/utils.js'

export default {
  name: 'domain',

  props: ['companyId'],

  data () {
    return {
      model: {
        domain_prefix: ''
      }
    }
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'admin', {
      loading: 'company/loading',
      company: 'company/one'
    }),

    domain_postfix () {
      return '.vcv.' + (this.isDomainRu() ? 'ru' : 'ai')
    },

    company() {
      return this.$store.getters[STORE_PREFIX + 'admin/company/one'];
    },

    company_domain_prefix: {
      get() {
        return this.company ? this.company.domain_prefix : false;
      },

      set(val) {
        this.model.domain_prefix = val
      }
    }
  },

  watch: {
    company: {
      handler: function (val) {
        if (!val) {
          return
        }

        this.model = Object.assign({}, val)
      },
      immediate: true
    }
  },

  methods: {
    update() {
      this.$store.dispatch(STORE_PREFIX + 'admin/company/update', {
        id: this.companyId,
        domain_prefix: this.model.domain_prefix
      })
    },
    isDomainRu() {
      return isDomainRu();
    },
  }
}
</script>

<style lang="scss" scoped>
  .domain-info-wrapper {
    padding-top: 32px;
  }

  .admin-domain-common-info-scene {
    .form-input {
      width: 60%;
    }
  }

  .row-desc {
    line-height: 40px;
  }

  .flex-block {
    display: flex;
    align-items: flex-start;
  }

  .flex-block--column {
    flex-direction: column;
  }

  .bold {
    margin-top: 4px;
    font-weight: 500;
  }
</style>
